import React, { Suspense, createContext, useState, useContext, useEffect } from 'react';
import BestVarietiesForm from './components/BestVarietiesForm/BestVarietiesForm';
import BestVarietiesProducts from './components/BestVarietiesProducts/BestVarietiesProducts';
import BestVarietiesTable from './components/BestVarietiesTable/BestVarietiesTable';
import './components/BestVarietiesForm/BestVarietiesForm.css';
import SelectFieldLoader from './components/SelectField/SelectFiled.loading';
import { useBestVarieties } from '@js/api';
import * as qs from 'qs';

function BestVarietiesLoading() {
  return (
    <section className="BestVarietiesForm">
      <picture className="BestVarietiesForm-image">
        <img src={window.IMG_EXPERT_SYSTEM} alt="Syteme expert Visuel" />
      </picture>
      <div className="BestVarietiesForm-rightBlock">
        <h1 className="BestVarietiesForm-title typo-brand-page-title">
          Consultez et choisissez les meilleures variétés adaptées à vos besoins
        </h1>
        <div className="BestVarietiesForm-form">
          {Array(5).fill(0).map((_, index) => <SelectFieldLoader key={`select-loading-${index}`} />)}
        </div>
      </div>
    </section>
  )
}

const FiltersContext = createContext();
export const useFiltersContext = () => useContext(FiltersContext);

export default function BestVarieties({ specie = 'sunflower' }) {

  const [params, setParams] = useState(
    qs.parse(window.location.search, { ignoreQueryPrefix: true })
  );
  const [filters, setFilters] = useState({});
  const { data, isError } = useBestVarieties({specie, ...params, filters}, {
    onSuccess: () => {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth'
      });
    },
    onError: () => {
      setParams(undefined);
    }
  });

  useEffect(() => {
    if (params) {
      const queryString = qs.stringify({ ...params });
      const url = new URL(window.location.href);
      url.search = queryString;
      window.history.pushState(null, '', url);
    }
  }, [params]);

  return (
    <div className="BestVarieties">
      <Suspense fallback={<BestVarietiesLoading />}>
        <BestVarietiesForm
          params={params}
          setParams={setParams}
          isError={isError} />
      </Suspense>

      {data?.products && (
        data.products.length !== 0 ? (
          <>
          <BestVarietiesProducts params={params} products={data?.products} />
          <FiltersContext.Provider value={{filters, setFilters}}>
            <BestVarietiesTable products={data?.products} />
          </FiltersContext.Provider>
        </>
        ) : (
          <div className="mt-8 alert alert--danger">Nous sommes désolés, aucune variété ne correspond à votre recherche. Pour plus d'informations et de précisions, contactez votre technicien LG.</div>
        )
      )}
    </div>
  )
}
